import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { dateFormat, getStoreType, timeFormat } from "../../../../../dynamicController";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import io from 'socket.io-client';

import step1 from "../../../../../assets/images/faq/duitnow1.png";
import step2 from "../../../../../assets/images/faq/duitnow2.png";
import step3 from "../../../../../assets/images/faq/duitnow3.png";
import step4 from "../../../../../assets/images/faq/duitnow4.png";

const mySwal = withReactContent(Swal);

const STORETYPE = getStoreType()

const DuitnowGuide = () => {

    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();

    const [duitnowUrl, setDuitnowUrl] = useState("");
    const [duitnowSrc, setDuitnowSrc] = useState("");
    const [duitnowImage, setDuitnowImage] = useState("");
    const [loading, setLoading] = useState(false);
    const [isIos/*, setIos*/] = useState(/iPhone|iPad|iPod/i.test(navigator.userAgent))
    const duitnowTitle = location.state?.title || "";
    const duitnowCreatedAt = location.state?.createdAt
        ? `${dateFormat(location.state.createdAt)} ${timeFormat(location.state.createdAt, true)}`
        : "";

    const buildDuitnowImageWithText = (imageSrc) => {
        return new Promise((resolve, reject) => {
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");

            if (!context) {
                reject(new Error("Unable to initialize canvas context"));
                return;
            }

            const img = new Image();
            const borderSize = 20;
            const fontSize = 14;
            const lineHeight = fontSize + 10;
            const hasMetaText = Boolean(duitnowTitle || duitnowCreatedAt);
            const textAreaHeight = hasMetaText ? lineHeight * 2 + 12 : 0;

            img.onload = () => {
                canvas.width = img.width + borderSize * 2;
                canvas.height = img.height + borderSize * 2 + textAreaHeight;

                context.fillStyle = "white";
                context.fillRect(0, 0, canvas.width, canvas.height);
                context.drawImage(img, borderSize, borderSize);

                if (hasMetaText) {
                    context.fillStyle = "black";
                    context.font = `${fontSize}px Arial`;
                    context.textAlign = "center";
                    const textX = canvas.width / 2;
                    const textY = img.height + borderSize * 2 + lineHeight;
                    context.fillText(duitnowTitle, textX, textY);
                    context.fillText(duitnowCreatedAt, textX, textY + lineHeight);
                }

                resolve(canvas.toDataURL("image/png"));
            };

            img.onerror = () => reject(new Error("Failed to load DuitNow image"));
            img.src = imageSrc;
        });
    };

    useEffect(() => {
        // if payment gateway return png image (RHB)
        if (location.state && location.state.image) {
            setDuitnowImage(location.state.image)
            buildDuitnowImageWithText(location.state.image)
                .then((imageWithText) => {
                    setDuitnowSrc(imageWithText);
                })
                .catch(() => {
                    setDuitnowSrc(location.state.image);
                });
        }

        // if payment gateway return url (PegePay)
        if (location.state && location.state.url) {
            setDuitnowUrl(location.state.url)
            setDuitnowSrc(location.state.url)

            setLoading(true);
            axios
                .post("/api/user/downloadDuitnowQr", { url: location.state.url, title: duitnowTitle, createdAt: duitnowCreatedAt }, { responseType: 'blob' })
                .then(response => {
                    const blob = response.data
                    const downloadUrl = URL.createObjectURL(blob);
                    setDuitnowSrc(downloadUrl)

                    if (!isIos) {
                        const a = document.createElement('a');
                        a.href = downloadUrl;
                        a.download = `duitnow_${dateFormat(new Date())}_${timeFormat(new Date())}.png`;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        // URL.revokeObjectURL(downloadUrl);
                    }

                    setLoading(false);
                })
                .catch(err => {
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                    setLoading(false);
                });
        }

        if (location.state && location.state.transactionId) {
            const socket = io({ transports: ['websocket'], auth: { transactionId: location.state.transactionId } })
            socket.on("duitnowPayment", (transactionId) => {
                if (location.state.role === "staff") {
                    history.push("/staff");
                } else {
                    history.push("/thankyou")
                }
            })

            return () => {
                socket.disconnect();
            };
        }

    }, []);

    const downloadQR = () => {
        setLoading(true);
        axios
            .post("/api/user/downloadDuitnowQr", { url: duitnowUrl, title: duitnowTitle, createdAt: duitnowCreatedAt }, { responseType: 'blob' })
            .then(response => {
                const blob = response.data
                const downloadUrl = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = downloadUrl;
                a.download = `duitnow_${dateFormat(new Date())}_${timeFormat(new Date())}.png`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(downloadUrl);
                setLoading(false);
            })
            .catch(err => {
                mySwal.fire(t("Error"), t(err.response.data.error), "error");
                setLoading(false);
            });
    }

    const donwloadImageQR = () => {
        const link = document.createElement("a");
        link.href = duitnowSrc || duitnowImage;
        link.download = `duitnow_${dateFormat(new Date())}_${timeFormat(new Date())}.png`;
        link.click();
    }

    return (
        <div id="setting-page" className="user-faq">
            <div id="setting-main">
                <div id="user-header">
                    <h5><i onClick={e => location.state?.role === "staff" ? history.push("/staff") : history.push("/")} className="bi bi-chevron-left me-3"></i> <strong>{t("Duitnow QR code")}</strong></h5>
                </div>

                <div id="user-body">
                    {
                        duitnowSrc ? (
                            <div className="pt-3 pb-3">
                                <h4 className="ps-3">{t("Your Duitnow QR code")}:</h4>
                                <div className="d-flex justify-content-center pb-2">
                                    <div style={{ backgroundColor: "#ED2E67", padding: "10px", borderRadius: "10px" }}>
                                        <div style={{ backgroundColor: "white", padding: "20px" }}>
                                            <img src={duitnowSrc} alt="duitnow-qr" />
                                        </div>
                                        <p style={{ paddingTop: "10px", textAlign: "center", color: "white", margin: 0, fontFamily: "'Calibri', sans-serif", fontWeight: "bold", fontSize: "16px" }}>MALAYSIA NATIONAL QR</p>
                                    </div>
                                </div>
                                {
                                    duitnowUrl ? (
                                        <div className="text-center">
                                            {/* <a className="btn btn-primary" href={`${getApiUrl()}/api/user/downloadDuitnowQr?url=${duitnowUrl}`} download={`duitnow_${dateFormat(new Date())}_${timeFormat(new Date())}.png`}>{t("Download")}</a> */}
                                            {
                                                loading ? (
                                                    <div className="text-center">
                                                        <div className={STORETYPE === "cuci" ? "spinner-border text-warning" : "spinner-border text-primary"} role="status">
                                                            <span className="sr-only">Loading ...</span>
                                                        </div>
                                                    </div>
                                                ) : <button className="btn btn-primary" onClick={() => downloadQR()}>{t("Download")}</button>
                                            }
                                        </div>
                                    ) : null
                                }
                                {
                                    duitnowImage ? (
                                        <div className="text-center">
                                            {/* <a
                                                className="btn btn-primary"
                                                href={duitnowImage}
                                                download={`duitnow_${dateFormat(new Date())}_${timeFormat(new Date())}.png`}
                                            >
                                                {t("Download")}
                                            </a> */}
                                            <button className="btn btn-primary" onClick={() => donwloadImageQR()}>{t("Download")}</button>
                                        </div>
                                    ) : null
                                }
                                {isIos ? <p className="text-center px-2 mt-2">{t('For iOS users, press and hold the image, then choose "Add to Photos" or "Save in Photos" from the menu.')}</p> : null}
                            </div>
                        ) : null
                    }

                    <h4 className="pt-3 ps-3">{t("How to pay using Duitnow QR code?")}</h4>

                    <div className="px-3 py-3 d-flex">
                        <div style={{ maxWidth: "30%" }}>
                            <img src={step1} alt="duitnow-guide-step1" className="img-fluid" />
                        </div>
                        <div className="align-content-center ps-2">
                            <h5>01 {t("Launch")}</h5>
                            <p>{t("Launch your preferred Mobile Banking or eWallet app.")}</p>
                        </div>
                    </div>

                    <div className="px-3 py-3 d-flex">
                        <div style={{ maxWidth: "30%" }}>
                            <img src={step2} alt="duitnow-guide-step2" className="img-fluid" />
                        </div>
                        <div className="align-content-center ps-2">
                            <h5>02 {t("Scan QR code from Gallery")}</h5>
                            <p>{t("Choose DuitNow QR from your gallery.")}</p>
                        </div>
                    </div>

                    <div className="px-3 py-3 d-flex">
                        <div style={{ maxWidth: "30%" }}>
                            <img src={step3} alt="duitnow-guide-step3" className="img-fluid" />
                        </div>
                        <div className="align-content-center ps-2">
                            <h5>03 {t("Pay")}</h5>
                            <p>{t("Confirm payment details and pay.")}</p>
                        </div>
                    </div>

                    <div className="px-3 py-3 d-flex">
                        <div style={{ maxWidth: "30%" }}>
                            <img src={step4} alt="duitnow-guide-step4" className="img-fluid" />
                        </div>
                        <div className="align-content-center ps-2">
                            <h5>04 {t("Confirmation")}</h5>
                            <p>{t("Receive payment confirmation.")}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DuitnowGuide;